import { DEMO_SURFACES_IN_BUILD, IS_PRODUCTION } from "@/lib/env";

export type DemoPartnerKey = "article" | "feather";

/**
 * The partner look a demo review path asks for, or `undefined`.
 *
 * The /article and /feather review routes pick their branding from the URL
 * path. In production those routes are not-found, so their branding must not
 * render either (it used to sit above the 404). `DEMO_SURFACES_IN_BUILD` lets a
 * production build drop the branches that read the answer; `IS_PRODUCTION`
 * covers any build that still carries them.
 *
 * Signed out (or while auth is still resolving) the answer is `undefined` too:
 * the routes send that visitor to /login, and the shell used to draw the
 * partner header and the Feather preview bar first, so a partner's branding
 * flashed before the login page.
 */
export function demoPartnerKeyForPath(pathname: string, signedIn: boolean): DemoPartnerKey | undefined {
  if (!DEMO_SURFACES_IN_BUILD || IS_PRODUCTION || !signedIn) return undefined;
  if (pathname === "/feather" || pathname.startsWith("/feather/")) return "feather";
  if (pathname === "/article" || pathname.startsWith("/article/")) return "article";
  return undefined;
}
